import type { AnyAction } from 'redux';
import { combineReducers } from 'redux';
import { common } from './commonReducer';
import { customer } from '../customer/customerReducer';
import { dealerships } from '../dealership/dealershipsReducer';
import { activeDeal } from '../activeDeal/activeDealReducer';
import { dealValidation } from '../dealValidation/dealValidationReducer';
import { confirmNavigationModal } from '../confirmNavigation/confirmNavigationReducer';
import { vehicle } from '../vehicle/vehicleReducer';
import { deals } from '../deals/dealsReducer';
import type { Reducer } from 'react';
import { workflowReducer } from '../workflow/workflowReducer';
import { dealRefreshDeferReducer } from '../dealRefreshDefer/dealRefreshDeferReducer';
import { showroomNav } from '../showroomNav/reducer';
import { financingReducer } from '../financing/financingReducer';
import { pdfShareLink } from '../pdfShareLink/pdfShareLinkReducer';
import { capabilities } from '../capabilities/reducer';
import { paymentGrids } from '../paymentGrids/paymentGridsReducer';
import type { SalesCheckinAppState } from './types/SalesCheckinAppState';

export const reducer: Reducer<SalesCheckinAppState, AnyAction> = combineReducers({
    common,
    customer,
    showroomNav,
    capabilities,
    dealerships,
    activeDeal,
    dealValidation,
    confirmNavigationModal,
    vehicle,
    deals,
    workflow: workflowReducer,
    dealRefreshDefer: dealRefreshDeferReducer,
    financing: financingReducer,
    pdfShareLink,
    paymentGrids
});
